import React from 'react';
import md5 from 'md5';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import {
    Box,
    Tooltip,
    IconButton,
    Avatar,
    Menu,
    MenuItem,
    Typography,
    Divider,
} from '@mui/material';
import logo from 'shared/src/assets/images/logo-client.jpeg'
import {logout} from 'shared/src/store/authSlice';

export default function AccountActions() {
  const { account } = useSelector(state=> state.authSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [avatarImage, setAvatarImage] = React.useState('');

    const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget);
    };
  
    const handleCloseUserMenu = () => {
      setAnchorElUser(null);
    };

    const handleNavegateProfile = () => {
      setAnchorElUser(null);
      navigate(`user/${account?.IDUser}/profile`);
    }

    const handleLogout = () => {
        dispatch(logout());
        setAnchorElUser(null);
        navigate(0);
    }

    React.useEffect(()=>{
      if(account === null){
        navigate(0);
      } else {
        setAvatarImage(`https://www.gravatar.com/avatar/${md5(account.email.toLowerCase().trim())}?d=identicon`);
      };
    },[account, navigate]);


    return(
        <Box sx={{marginLeft: 'auto'}}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Box
                    alt="app logo"
                    component="img"
                    sx={{
                      borderRadius: '50%!important',
                      width: '31px',

                    }}
                    src={logo}
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              
                <MenuItem onClick={handleNavegateProfile} sx={{display: 'none'}}> 
                  <Typography textAlign="left">Ver mi Perfil</Typography>
                </MenuItem>
              <MenuItem onClick={handleLogout}>
                <Typography textAlign="left">Cerrar Sesión</Typography>
              </MenuItem>
            </Menu>
        </Box>
    );
}